(function () {
  function bind() {
    const modal = document.querySelector('[data-quick-view-modal]');
    if (!modal) { setTimeout(bind, 500); return; }

    function openModal() {
      modal.setAttribute('aria-hidden','false');
      modal.classList.add('is-open');
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.setAttribute('aria-hidden','true');
      modal.classList.remove('is-open');
      modal.style.display = '';
      document.body.style.overflow = '';
    }

    async function addToCart(variantId, btn) {
      const orig = btn.textContent;
      btn.disabled = true; btn.textContent = '…';
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        }).then(r => r.json());
        btn.textContent = '✓'; btn.classList.add('is-added');
        if (window.almaOpenCart) setTimeout(window.almaOpenCart, 200);
        setTimeout(() => { btn.disabled = false; btn.textContent = orig; btn.classList.remove('is-added'); }, 1800);
      } catch (e) { btn.disabled = false; btn.textContent = orig; }
    }

    async function loadProduct(handle) {
      try {
        const r = await fetch('/products/' + encodeURIComponent(handle) + '.js');
        const p = await r.json();
        const img = modal.querySelector('[data-qv-image]');
        if (img) img.src = (p.featured_image || p.images?.[0] || '') + '';
        const t = modal.querySelector('[data-qv-title]'); if (t) t.textContent = p.title || '';
        const price = modal.querySelector('[data-qv-price]');
        if (price) price.textContent = '₪' + ((p.price || 0)/100).toFixed(2);
        const desc = modal.querySelector('[data-qv-description]');
        if (desc) { const tmp = document.createElement('div'); tmp.innerHTML = p.description || ''; desc.textContent = (tmp.textContent || '').slice(0, 220); }
        const variantsList = modal.querySelector('[data-qv-variants-list]');
        const variantInput = modal.querySelector('[data-qv-variant-input]');
        if (variantsList && p.variants && p.variants.length > 1) {
          variantsList.innerHTML = '';
          p.variants.forEach(function (v, idx) {
            var b = document.createElement('button'); b.type = 'button'; b.className = 'alma-qv__pill' + (idx===0?' is-active':''); b.textContent = v.title;
            b.addEventListener('click', function () {
              variantsList.querySelectorAll('.alma-qv__pill').forEach(function(x){x.classList.remove('is-active');});
              b.classList.add('is-active');
              if (variantInput) variantInput.value = v.id;
              if (price) price.textContent = '₪' + (v.price/100).toFixed(2);
            });
            variantsList.appendChild(b);
          });
          if (variantInput) variantInput.value = p.variants[0].id;
        } else {
          if (variantsList) variantsList.innerHTML = '';
          if (variantInput) variantInput.value = (p.variants?.[0] || {}).id || '';
        }
        const details = modal.querySelector('[data-qv-details]');
        if (details) details.href = '/products/' + p.handle;
        const loading = modal.querySelector('[data-qv-loading]'); if (loading) loading.style.display = 'none';
        const content = modal.querySelector('[data-qv-content]'); if (content) content.style.display = '';

        // Complementary products — ALWAYS clear first, then dedupe by href
        const compBlock = modal.querySelector('[data-qv-comp]');
        const compGrid = modal.querySelector('[data-qv-comp-grid]');
        if (compBlock && compGrid) {
          compBlock.style.display = 'none';
          compGrid.innerHTML = ''; // clear any previous state
          try {
            const html = await fetch('/products/' + encodeURIComponent(handle)).then(r => r.text());
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const cards = doc.querySelectorAll('.alma-pdp-comp__card');
            // Dedupe by href and limit to 2
            const seen = new Set();
            const uniqueCards = [];
            cards.forEach(function (c) {
              const href = (c.querySelector('.alma-pdp-comp__link') || c.querySelector('a'))?.getAttribute('href');
              if (href && !seen.has(href)) { seen.add(href); uniqueCards.push(c); }
            });
            const limited = uniqueCards.slice(0, 2);
            if (limited.length) {
              limited.forEach(function (c) {
                const linkEl = c.querySelector('.alma-pdp-comp__link') || c.querySelector('a');
                const href = linkEl?.getAttribute('href');
                const imgSrc = c.querySelector('img')?.getAttribute('src') || '';
                const name = c.querySelector('.alma-pdp-comp__name')?.textContent?.trim() || '';
                const price = c.querySelector('.alma-pdp-comp__price')?.textContent?.trim() || '';
                const variantId = c.getAttribute('data-variant-id') || c.querySelector('.alma-pdp-comp__add')?.getAttribute('data-add-id');
                const wrap = document.createElement('div');
                wrap.className = 'alma-qv__comp-card';
                wrap.innerHTML = '<a href="' + href + '" class="alma-qv__comp-link"><div class="alma-qv__comp-img"><img src="' + imgSrc + '" alt="" loading="lazy"></div><div class="alma-qv__comp-info"><h3 class="alma-qv__comp-name">' + name + '</h3><p class="alma-qv__comp-price">' + price + '</p></div></a>' + (variantId ? '<button type="button" class="alma-qv__comp-add" data-add-id="' + variantId + '" aria-label="הוסף לסל">+</button>' : '');
                compGrid.appendChild(wrap);
              });
              compBlock.style.display = '';
            }
          } catch (e) { console.warn('Comp fetch:', e); }
        }
      } catch (e) { console.error('QV load:', e); }
    }

    document.addEventListener('click', function (e) {
      const addBtn = e.target.closest('.alma-qv__comp-add');
      if (addBtn) {
        e.preventDefault(); e.stopPropagation();
        const vid = addBtn.getAttribute('data-add-id');
        if (vid) addToCart(vid, addBtn);
        return;
      }
      const btn = e.target.closest('.m-product-quickview-button, [data-quick-view-button]');
      if (!btn) return;
      const handle = btn.dataset.productHandle || btn.getAttribute('data-product-handle');
      if (!handle) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      const loading = modal.querySelector('[data-qv-loading]'); if (loading) loading.style.display = '';
      const content = modal.querySelector('[data-qv-content]'); if (content) content.style.display = 'none';
      openModal();
      loadProduct(handle);
      return false;
    }, true);

    modal.querySelectorAll('[data-qv-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.classList.contains('alma-qv__backdrop')) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });

    const form = modal.querySelector('[data-qv-form]');
    if (false) form.addEventListener('submit', function (e) {
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () { closeModal(); if (window.almaOpenCart) setTimeout(window.almaOpenCart, 300); })
        .catch(console.error);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
